import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { onErrorResumeNext } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CampaignModel } from 'src/app/models/CampaignModel';
import { CampaignTreeModel } from 'src/app/models/CampaignTreeModel';
import { CardResult } from 'src/app/models/CardResult';
import { RequestModel } from 'src/app/models/RequestModel';
import { TreesViewModel } from 'src/app/models/TreesViewModel';
import { LogicService } from 'src/app/services/logic.service';
import { TestFill } from 'src/app/utils/TestFill';

@Component({
    selector: 'app-step4',
    templateUrl: './step4.component.html',
    styleUrls: ['./step4.component.css']
})
export class Step4Component implements OnInit {
    get model(): TreesViewModel { return this._model; }
    @Input() set model(value: TreesViewModel) {
        this._model = value;
        this.campaign = value.campaign;
        this.request = value.request;
        if (value !== null) {
        }
    }
    request: RequestModel = null;
    campaign: CampaignModel = null;

    @Output() placeOrder = new EventEmitter();

    isSubmitted = false;
    couponMessageInvalid = '';
    couponMessage = '';

    disableBill = false;
    disableAddress = false;

    cardErrorMessage = '';

    private _model: TreesViewModel = null;

    paymentPrepForm: FormGroup = null;
    months = [
        { num: 1, numText: '01', text: 'January' },
        { num: 2, numText: '02', text: 'February' },
        { num: 3, numText: '03', text: 'March' },
        { num: 4, numText: '04', text: 'April' },
        { num: 5, numText: '05', text: 'May' },
        { num: 6, numText: '06', text: 'June' },
        { num: 7, numText: '07', text: 'July' },
        { num: 8, numText: '08', text: 'August' },
        { num: 9, numText: '09', text: 'September' },
        { num: 10, numText: '10', text: 'October' },
        { num: 11, numText: '11', text: 'November' },
        { num: 12, numText: '12', text: 'December' }
    ];

    years: number[] = [];

    summaryTrees: CampaignTreeModel[] = null;
    summaryTreesWait: CampaignTreeModel[] = null;

    mulchAdded : boolean = false;

    constructor(private fb: FormBuilder,
        public logic: LogicService) {
    }

    ngOnInit(): void {
        let year = new Date().getFullYear();
        for (let i = 0; i < 20; i++) {
            this.years.push(year++);

        }
        this.summaryTrees = this.campaign.trees.filter(t => t.qty > 0 && !t.isWaitlist);
        this.summaryTreesWait = this.campaign.trees.filter(t => t.qty > 0 && t.isWaitlist);
        this.initForm(this.request);

        this.mulchAdded = this.request.mulchFee > 0;
        this.calcTotal();
    }

    // setModel(model: RequestModel): void {
    //     this.model = model;
    //     this.initForm(this.model);
    //     // this.paymentPrepForm.reset(model);
    // }

    private initForm(model: RequestModel): void {

        this.paymentPrepForm = this.fb.group({
            couponCode: [model.couponCode, Validators.maxLength(16)],
            donationAmount: [model.donationAmount],
            // mulchFee: [model.mulchFee],
            treeTotalAmount: [model.treeTotalAmount],
            firstNameCard: [model.firstNameCard, [Validators.required, Validators.maxLength(32)]],
            lastNameCard: [model.lastNameCard, [Validators.required, Validators.maxLength(32)]],
            sameAsMail2: [model.sameAsMail2],
            billingAddress: [model.billingAddress, [Validators.required, Validators.maxLength(32)]],
            billingCity: [model.billingCity, [Validators.required, Validators.maxLength(32)]],
            billingState: [model.billingState, [Validators.required]],
            billingZip: [model.billingZip, [Validators.required, Validators.minLength(5)]],
            cardNumber: [model.cardNumber, [Validators.required, Validators.maxLength(64)]],
            expirationDate: [model.expirationDate, [Validators.required]],
            // expirationDate: [model.expirationDate, [Validators.required, Validators.pattern('^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$')]],
            // expirationDate: [model.expirationDate, Validators.required],
            cvv: [model.cvv, [Validators.required, Validators.minLength(3)]],

        });

        if (model.amountDueNow <= 0 && model.waitListAmount <= 0) {
            this.disableBill = true;
        }
        this.paymentPrepForm.controls.donationAmount.valueChanges
            // .pipe(debounceTime(200))
            .subscribe(v => {
                if (this.paymentPrepForm.controls.donationAmount.value < 0) {
                    this.paymentPrepForm.controls.donationAmount.setValue(-this.paymentPrepForm.controls.donationAmount.value);
                }
                this.calcTotal();
            });

        this.paymentPrepForm.controls.couponCode.valueChanges
            // .pipe(debounceTime(200))
            .subscribe(v => {
                this.checkCoupon(v);
            });

        this.paymentPrepForm.controls.sameAsMail2.valueChanges.subscribe(checked => {
            this.disableAddress = false;
            if (checked) {
                this.paymentPrepForm.controls.billingAddress.setValue(this.request.mailAddress);
                this.paymentPrepForm.controls.billingCity.setValue(this.request.mailCity);
                this.paymentPrepForm.controls.billingState.setValue(this.request.mailState);
                this.paymentPrepForm.controls.billingZip.setValue(this.request.mailZip);
                this.disableAddress = true;
            }
        });

    }


    billingOn() {
        this.paymentPrepForm.controls.firstNameCard.setValidators([Validators.required, Validators.maxLength(32)]);
        this.paymentPrepForm.controls.lastNameCard.setValidators([Validators.required, Validators.maxLength(32)]);
        this.paymentPrepForm.controls.billingAddress.setValidators([Validators.required, Validators.maxLength(32)]);
        this.paymentPrepForm.controls.billingCity.setValidators([Validators.required, Validators.maxLength(32)]);
        this.paymentPrepForm.controls.billingState.setValidators([Validators.required]);
        this.paymentPrepForm.controls.billingZip.setValidators([Validators.required, Validators.max(99999)]);
        this.paymentPrepForm.controls.cardNumber.setValidators([Validators.required, Validators.maxLength(64)]);
        this.paymentPrepForm.controls.expirationDate.setValidators([Validators.required]);
        this.paymentPrepForm.controls.cvv.setValidators([Validators.required, Validators.pattern('^[0-9]{3,4}$')]);
    }

    get f(): any { return this.paymentPrepForm.controls; }

    savePaymentPrep(): void {
        // this.model = {...this.model, ...this.requestForm.value};
        this.updateModel(this.request, this.paymentPrepForm);

    }
    updateModel(model: RequestModel, form: FormGroup): void {
        model.couponCode = form.controls.couponCode.value;
        model.donationAmount = form.controls.donationAmount.value;
        model.treeTotalAmount = form.controls.treeTotalAmount.value;
        model.firstNameCard = form.controls.firstNameCard.value;
        model.lastNameCard = form.controls.lastNameCard.value;
        model.sameAsMail2 = form.controls.sameAsMail2.value;
        model.billingAddress = form.controls.billingAddress.value;
        model.billingCity = form.controls.billingCity.value;
        model.billingState = form.controls.billingState.value;
        model.billingZip = form.controls.billingZip.value;
        model.cardNumber = form.controls.cardNumber.value;
        model.expirationDate = form.controls.expirationDate.value;
        model.cvv = form.controls.cvv.value;
    }

    isDitry(): boolean {
        return this.paymentPrepForm.dirty;
    }

    isValid(): boolean {
        return this.paymentPrepForm.valid || this.disableBill;
    }

    checkCoupon(v: string): void {
        this.couponMessage = '';
        this.couponMessageInvalid = '';
        this.request.couponMultiplier = 1;
        if (!v || v === '') {
            this.calcTotal();
            return;
        }
        v = v.toUpperCase();
        for (const coupon of this.campaign.coupons) {
            if (coupon.couponCode.toUpperCase() === v) {
                this.request.couponMultiplier = coupon.couponMultiplier;
                this.calcTotal();
                this.couponMessage = `${(1 - coupon.couponMultiplier) * 100}% OFF coupon applied`;
                return;
            }
        }
        this.calcTotal();
        this.couponMessageInvalid = 'Invalid coupon code';
    }

    calcTotal = () => {
        const t = this.paymentPrepForm.controls.treeTotalAmount.value;
        const d = this.paymentPrepForm.controls.donationAmount.value;
        const total = t * this.request.couponMultiplier + d + this.request.mulchFee;
        this.request.amountDueNow = total;
        this.disableBill = total <= 0 && this.request.waitListAmount <= 0;
    }


    placeOrderClick(): void {
        this.isSubmitted = true;
        this.cardErrorMessage = null;
        this.placeOrder.emit();
    }

    cardError(order: RequestModel) {
        this.isSubmitted = false;
        this.cardErrorMessage = ''; //rder.profileResult.errorMessage + order.chargeResult.errorMessage
        if (order.profileResult.errorMessage) {
            this.cardErrorMessage += order.profileResult.errorMessage;
        }
        if (order.chargeResult.errorMessage) {
            this.cardErrorMessage += order.chargeResult.errorMessage;
        }
    }


    addMulch() {
        this.mulchAdded = !this.mulchAdded;
        if (this.mulchAdded) {

            this.request.mulchFee = this.request.isTargetNeighborhood ?
             this.campaign.targetNeighborhoodMulchFee :
              this.campaign.normalNeighborhoodMulchFee;
        }
        else{
            this.request.mulchFee = 0;
        }
        this.calcTotal();
    }

    // Test only
    //
    fill(): void {
        const testfill = new TestFill();
        // testfill.fillPay(this.request);
        this.initForm(this.request);
    }
}
